export const MIXPANEL_EVENT_DATA_DEFAULT = { 'Source Component': 'Header' };
